import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import FacebookBusiness from 'fg-frontend/components/FacebookBusiness/FacebookBusiness';

export default class WebLayout extends WebComponent {

  constructor(props) {
    super(props);
  }

  didMount() {
    this.facebookBusiness = new FacebookBusiness(this.props);
    this.facebookBusiness.decorate(this.element);
  }

  willUnMount() {
    this.facebookBusiness.dispose();
    this.facebookBusiness = undefined;
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/WebLayout.js